/* CONIUNCTA Erklaerblaeschen am Variantenpicker (snippets/coni-option-hilfe.liquid).
   Setzt je Option ein "?" in die Label-Zeile von <variant-selects> und zeigt ein Blaeschen mit der Erklaerung
   (Klick haelt es offen, Hover zeigt es auf Geraeten mit Maus, Escape oder Klick daneben schliesst).
   Das Theme (Hyper/FoxTheme) tauscht den Picker bei jedem Variantenwechsel aus: MutationObserver setzt die Buttons erneut.
   Die Buttons liegen im <label> des Selects: Klicks im Blaeschen werden abgefangen, damit das Label das Select nicht oeffnet. */
(function () {
  'use strict';
  var HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Erklaerung je Option, sprachunabhaengig ueber die Werte (Storefront-Uebersetzungen aendern die Namen).
  function category(input, idx) {
    if (idx === 0) return 'groesse';
    var vals = '';
    var opts = input.querySelectorAll('select option, input[type="radio"]');
    for (var i = 0; i < opts.length; i++) vals += '|' + (opts[i].value || opts[i].textContent || '');
    vals = vals.toLowerCase();
    if (vals.indexOf('ifoam') !== -1) return 'qualitaet';
    if (vals.indexOf('jojoba') !== -1 || vals.indexOf('squalan') !== -1) return 'oelbasis';
    if (vals.indexOf('glyc') !== -1 || vals.indexOf('glic') !== -1 || vals.indexOf('glykol') !== -1) return 'konservierung';
    return '';
  }

  function inject(data, sid) {
    var pickers = document.querySelectorAll('variant-selects[data-section="' + sid + '"]');
    Array.prototype.forEach.call(pickers, function (picker) {
      var inputs = picker.querySelectorAll('.product-form__input');
      Array.prototype.forEach.call(inputs, function (input, idx) {
        if (input.querySelector('.coni-hilfe')) return;
        var cat = category(input, idx);
        if (!cat || !data[cat]) return;
        var row = input.querySelector('.form__label .flex') || input.querySelector('.form__label') || input.querySelector('label, legend');
        if (!row) return;
        var nameEl = input.querySelector('.form__label .font-body-bolder');
        var optName = nameEl ? nameEl.textContent.replace(/:\s*$/, '').trim() : '';
        var label = String(data.open || '').replace('[option]', optName);
        var id = 'coni-hilfe-' + sid + '-' + idx;
        var wrap = document.createElement('span');
        wrap.className = 'coni-hilfe';
        wrap.innerHTML =
          '<button type="button" class="coni-hilfe__btn" aria-expanded="false" aria-controls="' + id + '" title="' + esc(label) + '">' +
            '<span class="coni-hilfe__sr">' + esc(label) + '</span><span aria-hidden="true">?</span></button>' +
          '<span class="coni-hilfe__pop" id="' + id + '" role="tooltip" hidden>' + data[cat] + '</span>';
        row.appendChild(wrap);
      });
    });
  }

  function place(h) {
    var pop = h.querySelector('.coni-hilfe__pop');
    if (!pop || pop.hidden) return;
    pop.style.left = '0px';
    var vw = document.documentElement.clientWidth;
    var br = h.getBoundingClientRect();
    var pr = pop.getBoundingClientRect();
    var left = 0;
    if (br.left + pr.width > vw - 12) left = (vw - 12) - (br.left + pr.width);
    if (br.left + left < 12) left = 12 - br.left;
    pop.style.left = left + 'px';
    pop.style.setProperty('--coni-hilfe-caret', (0.4 * 10 - left) + 'px');
  }

  function setOpen(h, on) {
    var btn = h.querySelector('.coni-hilfe__btn');
    var pop = h.querySelector('.coni-hilfe__pop');
    if (!btn || !pop) return;
    h.classList.toggle('is-open', on);
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    pop.hidden = !on;
    if (!on) h.dataset.pinned = '';
    if (on) place(h);
  }

  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('.coni-hilfe.is-open'), function (h) {
      if (h !== except) setOpen(h, false);
    });
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var h = t.closest('.coni-hilfe');
    if (!h) { closeAll(null); return; }
    if (t.closest('a')) return;
    ev.preventDefault();
    if (t.closest('.coni-hilfe__btn')) {
      if (h.dataset.pinned) {
        setOpen(h, false);
      } else {
        closeAll(h);
        setOpen(h, true);
        h.dataset.pinned = '1';
      }
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' || ev.key === 'Esc') closeAll(null);
  });
  if (HOVER) {
    document.addEventListener('mouseover', function (ev) {
      var h = ev.target && ev.target.closest ? ev.target.closest('.coni-hilfe') : null;
      if (h && !h.classList.contains('is-open')) { closeAll(h); setOpen(h, true); }
    });
    document.addEventListener('mouseout', function (ev) {
      var h = ev.target && ev.target.closest ? ev.target.closest('.coni-hilfe') : null;
      if (!h || h.dataset.pinned) return;
      var to = ev.relatedTarget;
      if (to && h.contains(to)) return;
      setOpen(h, false);
    });
  }
  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.coni-hilfe.is-open'), place);
  });

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.coni-hilfe-data'), function (node) {
      if (node.dataset.coniHilfeReady) return;
      node.dataset.coniHilfeReady = '1';
      var data;
      try { data = JSON.parse(node.textContent); } catch (e) { return; }
      var sid = node.dataset.sectionId || '';
      var run = function () { inject(data, sid); };
      run();
      // Das Theme tauscht <variant-selects> bei jedem Variantenwechsel aus: danach erneut setzen.
      // setTimeout statt requestAnimationFrame, damit es auch in Hintergrund-Tabs laeuft.
      var scope = node.closest('product-info') || document.body;
      var timer = null;
      var later = function () {
        if (timer) return;
        timer = window.setTimeout(function () { timer = null; run(); }, 40);
      };
      if (window.MutationObserver) {
        new MutationObserver(later).observe(scope, { childList: true, subtree: true });
      }
      try {
        if (window.FoxTheme && FoxTheme.pubsub && typeof FoxTheme.pubsub.subscribe === 'function') {
          FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
            later();
            window.setTimeout(run, 400);
          });
        }
      } catch (e) { /* ohne pubsub reicht der Observer */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
